import api from '../../api'

export default {
  name: 'Feedback',
  data: () => {
    return {
      message: ''
    }
  },
  methods: {
    sendFeedback () {
      api.post.sendFeedback(this.message).then(() => {
        this.message = ''
        this.$notify({
          message: 'Сообщение отправлено',
          type: 'success'
        })
      })
    }
  }
}
